export default __webpack_public_path__ + "static/media/iOS.67b3ca5d.svg";